import { BarChart, LineChart } from 'components/Visualization/Charts';

export const availableWidgetMap: Record<string, any> = {
  lineChart: LineChart,
  barChart: BarChart,
};
